export const CONCURSOS_SELECIONAR_CONCURSO = "@CONCURSOS/SELECIONAR_CONCURSO";
export function setConcursoAtual(consurso) {
  return {
    type: CONCURSOS_SELECIONAR_CONCURSO,
    payload: consurso,
  };
}



// WEBPACK FOOTER //
// ./src/reducers/concursos/concursosActions.js